import { useEffect, useState } from 'react';
import { useOrders } from '../../contexs/orders-context';
import notificationSounds from '../../utils/notification-sounds';

enum PlaySoundState {
  Once,
  Loop,
  None,
}

export const CashRegisterOrderNotification = () => {
  const { registerCallback } = useOrders();
  const [playSound, setPlaySound] = useState<PlaySoundState>(
    PlaySoundState.None,
  );

  const updatePlaySound = (sound: PlaySoundState) => {
    setPlaySound(prev => {
      if (prev === PlaySoundState.Loop && sound === PlaySoundState.Once) {
        // Prevent transitioning directly from Loop to Once, reset to None instead
        return PlaySoundState.None;
      }

      if (prev === PlaySoundState.Once && sound === PlaySoundState.None) {
        // No state update needed if transitioning from Once to None
        return prev;
      }

      // Otherwise, allow the state change
      return sound;
    });
  };

  // When there are new orders, play the sound once
  useEffect(() => {
    const unregisterCallback = registerCallback(
      'CashRegisterOrderNotification',
      async (newOrders, orders) => {
        const anyUnestimatedOrder = orders.find(order => !order.estimated_at);
        const isOnline = window.location.pathname.includes('vendor');

        if (anyUnestimatedOrder || (newOrders.length > 0 && !isOnline)) {
          updatePlaySound(PlaySoundState.Loop);
        } else if (newOrders.length > 0) {
          updatePlaySound(PlaySoundState.Once);
        } else {
          updatePlaySound(PlaySoundState.None);
        }
      },
    );

    return () => {
      unregisterCallback();
    };
  }, [window.location.pathname]);

  useEffect(() => {
    const bellSound = notificationSounds.bell();
    const isSoundLooping = bellSound.getNumberOfLoops() === -1;

    const handlePlaySound = () => {
      console.log('PLAY SOUND', playSound);
      if (playSound === PlaySoundState.Loop) {
        if (!isSoundLooping) {
          bellSound.setNumberOfLoops(-1);

          if (!bellSound.isPlaying()) {
            bellSound.play();
          }
        }
      } else {
        bellSound.setNumberOfLoops(0);

        if (playSound === PlaySoundState.Once) {
          if (!bellSound.isPlaying()) {
            bellSound.play();
          }
        }
      }
    };

    handlePlaySound();

    return () => {
      bellSound.release();
    };
  }, [playSound]);

  return null;
};
